const Testinomials = [
{
    id : 1,
    feedback : "I was looking for a Website professional who would create and evolve my website. He delivers exactly what I wanted. I know he will keep improving my website with SEO and new features for years.",
    name : "Colin Sanburg (TA - Corporation)"
},
{
    id : 3,
    feedback : "We developed our website twice in 12 months. There was no comparison between the first developer and him. Professional, Creative, Attentive to Detail, Excellent Communication…Definitely Recommended.",
    name : "Aaron Miller (Adano Company)"
},
{
    id : 2,
    feedback : "I appreciate the dedication you had put in my project. It is nice from the customer's point of view to be able to get in touch with you anytime i wanted. You did a great job for me. Thanks! Once Again.",
    name : "Blair Valk (Unified Supply)"
},

]


export default Testinomials
